import React from 'react';
import { MailIcon, InstagramIcon, GlobeIcon } from 'lucide-react';
export function Footer() {
  return <footer className="w-full bg-ivory px-4 py-8 sm:px-6" data-id="element-92" data-mp="3gfiu2hdxs9dl">
      <div className="mx-auto max-w-3xl text-center" data-id="element-93" data-mp="3gh3sii3dgcgq">
        <p className="font-head text-lg font-extrabold uppercase text-charcoal sm:text-xl" data-id="element-94" data-mp="32p5mwh8vcypb">
          Yoga Teaching Vault™
        </p>
        <p className="mt-1 text-sm leading-snug text-softgray" data-id="element-95" data-mp="36nd1p6jrvpxv">
          The complete ready-to-teach system for yoga instructors. Because teaching yoga should not
          require rebuilding every class from scratch.
        </p>

        <ul className="mt-3 flex flex-wrap items-center justify-center gap-x-4 gap-y-1 text-xs text-softgray sm:text-sm" data-id="element-96" data-mp="3levhb38pzigp">
          <li className="flex items-center gap-1.5" data-id="element-97" data-mp="3qcdtr3ly4ftg">
            <MailIcon className="h-3.5 w-3.5 text-brand" aria-hidden="true" data-id="element-98" data-mp="29z6tk9nn6feu" />
            Support:{' '}
            <a href="mailto:kitonline27@gmail.com" className="underline hover:text-brand" data-id="element-99" data-mp="2eya1c1v0azqi">
              kitonline27@gmail.com
            </a>
          </li>
          <li className="flex items-center gap-1.5" data-id="element-100" data-mp="3la29euiur3v8">
            <InstagramIcon className="h-3.5 w-3.5 text-brand" aria-hidden="true" data-id="element-101" data-mp="3gapfjptkcwj5" />
            Instagram: Kit Online
          </li>
          <li className="flex items-center gap-1.5" data-id="element-102" data-mp="3v8hqe4o60wr0">
            <GlobeIcon className="h-3.5 w-3.5 text-brand" aria-hidden="true" data-id="element-103" data-mp="3q8n1g6nyah8l" />
            Website: Kit Online
          </li>
        </ul>

        <p className="mt-4 text-[11px] text-softgray" data-id="element-104" data-mp="81yx4j0q5y3z">
          © 2026 Kit Online — All Rights Reserved.
        </p>
        <p className="mx-auto mt-2 max-w-2xl text-[11px] leading-snug text-softgray" data-id="element-105" data-mp="33e69a7d4qs7">
          The information and resources provided are intended for educational purposes and do not
          replace accredited yoga teacher training, medical advice, diagnosis, or treatment.
          Instructors remain responsible for adapting all materials to their qualifications,
          students, and teaching environment.
        </p>
        <p className="mt-2 text-[11px] text-softgray" data-id="element-106" data-mp="mq3ftmzs29mr">
          Terms &amp; Conditions · Privacy Policy · Contact
        </p>
      </div>
    </footer>;
}